import styled from "styled-components";

export const ExportLogsBtnContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xs);
`;
